module.exports = __webpack_public_path__ + "img/CHIC.70bc7816.jpg";